export default __webpack_public_path__ + "static/video-placeholder-dev-f61236eb7dac2051439352e8137fb647.jpg";